<template>
  <modal-padrao
    ref="modal"
    max-width="1200px"
    :titulo="
      $t('modulos.calibracao.valores.titulos.confirmar_instrumento_padrao')
    "
    :persistente="persistente"
    :mostrar-botao-cancelar="!persistente"
    :ok-desabilitado="!todosPontosSelecionados()"
    :titulo-ok="$t('modulos.calibracao.valores.titulos.confirmar')"
    @ok="alterarInstrumento"
  >
    <div>
      <v-alert v-if="!todosPontosSelecionados()" color="red" type="error">
        Existem pontos de calibração sem instrumentos padrões, por favor associe
        algum instrumento para esses casos para continuar calibrando!
      </v-alert>
      <accordion-padrao
        nao-retrair
        :titulo="$t('modulos.calibracao.valores.modal.variaveis')"
      >
        <input-radio
          v-model="form.variavel"
          class-grupo="d-flex flex-column"
          :options="opcoesVariaveisComputadas"
        >
          <template #label="{ opcao }">
            <div
              class="d-flex"
              :class="
                !todosPontosSelecionadosVariavel(opcao.value) ? 'red--text' : ''
              "
            >
              <span class="mr-2">{{ opcao?.text }}</span>
              <icone-padrao
                v-if="!todosPontosSelecionadosVariavel(opcao.value)"
                cor="red"
                icone="$warning"
                class="pl-2"
                :tooltip="`Alguns pontos (${opcao.pontosNaoAtribuidos
                  .map((el) => el.ponto?.text)
                  .join(
                    ', '
                  )}) estão sem instrumento padrão atribuídos para essa variável`"
              />
            </div>
          </template>
        </input-radio>
      </accordion-padrao>
      <!-- Seleção de Pontos  -->
      <accordion-padrao
        nao-retrair
        :titulo="$t('modulos.calibracao.valores.modal.pontos')"
      >
        <div v-for="opcao in opcoesPontos" :key="opcao.value" class="d-flex">
          <input-checkbox
            v-model="form.pontos"
            :label="opcao.text"
            :valor="opcao.value"
            style="width: 150px"
            class="mb-1"
          />
          <!-- :disabled="verificarPontoDisabled(opcao)" -->
          <v-chip
            v-if="pontosNaoAtribuidos.find((v) => v?.value == opcao.value)"
            label
            color="error"
            small
          >
            {{
              $t(
                'modulos.calibracao.tabela_calibracao.ponto_sem_instrumento_atribuido'
              )
            }}
          </v-chip>
        </div>
      </accordion-padrao>
      <template v-if="form.variavel">
        <!-- Instrumentos Padrão -->
        <accordion-padrao
          nao-retrair
          :titulo="$t('modulos.calibracao.valores.modal.instrumento_atual')"
        >
          <tabela-padrao
            :key="keyAtualizaInstrumentos"
            :colunas="tabela.colunasAtuais"
            item-key="faixaSelecionada"
            :dados="instrumentosAtuais(true)"
            sem-acoes
            sem-paginacao
            :mostrar-checkbox="false"
          >
            <template v-slot:item.faixas="{ item }">
              <div>
                {{
                  buscarFaixaInstrumento(
                    item?.item?.faixaSelecionada,
                    item?.item?.faixas
                  )
                }}
              </div>
            </template>
            <template v-slot:item.pontos="{ item }">
              <div>
                {{ encontrarTextoPorId(item.item.pontos) }}
              </div>
            </template>
            <template v-slot:item.acoes="{ item }">
              <div>
                <v-icon
                  size="20"
                  color="error"
                  style="cursor: pointer"
                  @click="removerInstrumentoPadrao(item.item)"
                >
                  $mdiTrashCanOutline
                </v-icon>
                {{ item.value }}
              </div>
            </template>
          </tabela-padrao>
        </accordion-padrao>
        <accordion-padrao
          nao-retrair
          :titulo="$t('modulos.calibracao.valores.modal.novo_instrumento')"
        >
          <v-alert v-if="selecionarMaisDeUm()" type="warning">
            Esta variável permite selecionar mais de um instrumento padrão.
          </v-alert>
          <tabela-padrao-prime-vue
            :key="keyAtualiza"
            v-model="tabela.selecionados"
            style="min-height: 300px"
            :colunas="tabela.colunas"
            :dados="tabela.dados"
            linha-hover
            :mostrar-seletor="false"
            mostrar-seletor-check-box
            filtros-com-colunas
            filtro-global-focus
            :mostrar-acoes="false"
            :quantidade-itens="tabela.quantidadeItens"
            :por-pagina="tabela.porPagina"
            :quantidade-paginas="tabela.quantidadePaginas"
            :pagina="tabela.paginaAtual"
            :selecionar-apenas-um="false"
            ajustar-altura-linha
            @paginar="listarRegistros"
            @filtrarGlobal="filtrar"
            @filtroGlobal="(v) => (filtro.filter = v)"
          >
            <template v-slot:seletor="{ slotProps }">
              <div>
                <v-simple-checkbox
                  v-if="podeSelecionar(slotProps.data)"
                  v-model="slotProps.data.isSelected"
                  @input="SelecionarInstrumentoPadrao(slotProps.data)"
                />
              </div>
            </template>
            <template v-slot:faixas="{ slotProps }">
              <div>
                <input-select
                  v-model="slotProps.data.faixaSelecionada"
                  :options="formatarFaixas(slotProps.data.faixas)"
                  sem-label
                  class="input-tabela my-1"
                  placeholder="Selecione"
                  style="width: 250px"
                />
              </div>
            </template>
          </tabela-padrao-prime-vue>
        </accordion-padrao>
      </template>
    </div>
  </modal-padrao>
</template>
<script>
import { InstrumentoService, FormulaService } from '@common/services';
import _ from 'lodash';

export default {
  props: {
    valores: { type: Object, default: () => {} },
    instrumentoId: { type: String, default: '' },
    tabelaSelecionada: { type: Object, default: () => {} },
  },
  data() {
    return {
      persistente: false,
      variavelSetada: false,
      valoresClonados: null,
      form: {
        variavel: null,
        pontos: [],
        somatorioPontos: true,
      },
      filtro: {
        flagPadrao: true,
        filter: '',
      },
      opcoesVariaveis: [],
      tabela: {
        selecionados: [],
        dados: [],
        colunas: [
          {
            value: 'codigo',
            text: this.$t('modulos.calibracao.valores.modal.tabela.codigo'),
            sortable: false,
          },
          {
            value: 'tipoInstrumento.nome',
            text: this.$t(
              'modulos.calibracao.valores.modal.tabela.tipo_instrumento'
            ),
            sortable: false,
          },
          {
            value: 'faixas',
            text: this.$t('componentes.input_instrumento_padrao.tabela.faixas'),
            sortable: false,
          },
          {
            value: 'setor.nome',
            text: this.$t('modulos.calibracao.valores.modal.tabela.setor'),
            sortable: false,
          },
          {
            value: 'validacao',
            text: this.$t('modulos.calibracao.valores.modal.tabela.situacao'),
            sortable: false,
            formatter: (v) => {
              return this.$t(`enums.EnumInstrumentoPadraoValidacao.${v}`);
            },
          },
        ],
        colunasAtuais: [
          {
            value: 'codigo',
            text: this.$t('modulos.calibracao.valores.modal.tabela.codigo'),
            sortable: false,
          },
          {
            value: 'tipoInstrumento.nome',
            text: this.$t(
              'modulos.calibracao.valores.modal.tabela.tipo_instrumento'
            ),
            sortable: false,
          },
          {
            value: 'faixas',
            text: this.$t('componentes.input_instrumento_padrao.tabela.faixas'),
            sortable: false,
          },
          {
            value: 'setor.nome',
            text: this.$t('modulos.calibracao.valores.modal.tabela.setor'),
            sortable: false,
          },
          {
            value: 'pontos',
            text: this.$t('modulos.calibracao.valores.modal.tabela.pontos'),
            sortable: false,
          },
          {
            value: 'acoes',
            text: '',
          },
        ],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        paginaAtual: 1,
        porPagina: 10,
        pontosCalibracaoFormatados: '',
        ignorarWatcherPontos: false,
      },
      keyAtualiza: 0,
      keyAtualizaInstrumentos: 0,
      controlePaginacao: {},
      instrumentosPadroesState: [],
    };
  },
  computed: {
    pontosVazios: function () {
      return this.pontosSemInstrumento
        .filter((value, index, array) => {
          return (
            array.indexOf(
              array.find((el) => {
                return (
                  el.formulaVariavel.id == value.formulaVariavel.id &&
                  el.instrumentoFaixaPontoId == value.instrumentoFaixaPontoId
                );
              })
            ) === index
          );
        })
        .map((el) => {
          el.ponto = this.opcoesPontos.find(
            (v) => v?.value == el.instrumentoFaixaPontoId
          );
          return el;
        });
    },
    opcoesVariaveisComputadas: function () {
      return this.opcoesVariaveis.map((el) => {
        el.pontosNaoAtribuidos = this.pontosVazios.filter(
          (pv) => pv.formulaVariavel.id == el.value
        );
        return el;
      });
    },
    variaveisComputadas() {
      return this.opcoesVariaveisComputadas.map((el) => el.value);
    },
    atualizarPontos: function () {
      return this.pontosVazios.filter(
        (el) => el.formulaVariavel.id == this.form.variavel
      );
    },
    pontosNaoAtribuidos: function () {
      if (!this.form.variavel) return [];
      return this.pontosVazios
        .filter((el) => el.formulaVariavel.id == this.form.variavel)
        .map((el) => {
          return el.ponto;
        });
    },
    opcoesPontos: function () {
      if (!this.valoresClonados) return [];
      return this.valoresClonados.linhas
        .filter((value, index, array) => {
          const linha = array.find(
            (el) => el.pontoCalibracao.id == value.pontoCalibracao.id
          );
          return (
            array.indexOf(linha) === index &&
            linha.calibracaoFaixaId == this.tabelaSelecionada.faixaId
          );
        })
        .map((el) => {
          return {
            value: el.pontoCalibracao.id,
            text: `${el.pontoCalibracao.valor} - ${el.pontoCalibracao.unidadeMedida.nome}`,
          };
        });
    },
    pontosSemInstrumento: function () {
      if (!this.valoresClonados) return [];
      return this.valoresClonados.instrumentosPadroes.filter(
        (x) => !x.instrumento
      );
    },
  },
  watch: {
    'form.variavel': function (v) {
      this.selecionarPontos();
      this.resetarFiltroComMudancaDoFormVariavelOuPontos(v, true);
    },
    'form.pontos': function () {
      if (this.ignorarWatcherPontos) return (this.ignorarWatcherPontos = false);
      this.resetarFiltroComMudancaDoFormVariavelOuPontos(null, true);
    },
  },
  methods: {
    buscarFaixaInstrumento(faixaId, faixas = []) {
      const faixa = faixas.find((f) => f.id == faixaId);
      return faixa?.nome;
    },
    callBackValidaInstrumento: function (i, instrumento) {
      // Filtro por variável, Calibração Faixa, Id, e Faixa Selecionada;
      const bool =
        i.id == instrumento.id &&
        i.faixaSelecionada == instrumento.faixaSelecionada &&
        (instrumento.variavelId
          ? i.variavelId == instrumento.variavelId
          : true) &&
        i.instrumentoCalibracaoFaixaId == this.tabelaSelecionada.faixaId;
      return bool;
    },
    definirinstrumentosPadroesState() {
      // Insere os padrões dos valoresClonados no state obj formatado.
      this.instrumentosPadroesState = this.valoresClonados.instrumentosPadroes
        .filter((p) => p.instrumento && p.instrumentoCalibracaoFaixa)
        .map((p) => {
          return {
            ...p,
            pontos: p.pontos.map((pi) => pi.calibracaoFaixaPonto.id),
            variavelId: p.formulaVariavel.id,
            faixaSelecionada: p.faixa.id,
            faixas: [{ ...p.faixa, nome: p.faixa?.descricao }],
            codigo: p.instrumento.codigoTag,
            id: p.instrumento.id,
            tipoInstrumento: p.instrumento.tipoInstrumento,
            instrumentoCalibracaoFaixaId: p.instrumentoCalibracaoFaixa?.id,
          };
        });
      ++this.keyAtualizaInstrumentos;
    },
    removerInstrumentoPadrao(instrumento) {
      // Remove o padrão já selecionado anteriorente do state
      _.remove(this.instrumentosPadroesState, (i) =>
        this.callBackValidaInstrumento(i, instrumento)
      );
      ++this.keyAtualizaInstrumentos;

      this.tabela.selecionados.forEach((p) => {
        const pontos = p.pontos.concat(instrumento.pontos);
        p.pontos = _.uniq(pontos);
      });
    },
    instrumentosAtuais(
      filtrarVariavel = false,
      variavelId = null,
      ignorarFaixa = false
    ) {
      // Retorna os padrões do state e os em seleção (tabela.selecionados).
      return this.instrumentosPadroesState
        .filter((el) =>
          ignorarFaixa
            ? true
            : el.instrumentoCalibracaoFaixaId == this.tabelaSelecionada.faixaId
        )
        .filter((el) =>
          filtrarVariavel
            ? el.variavelId == (variavelId || this.form.variavel)
            : true
        );
    },
    selecionarPontos: function () {
      this.variavelSetada = true;
      if (this.form.pontos.length) return;
      this.opcoesPontos.forEach((ponto) => {
        this.form.pontos.push(ponto.value);
      });
    },
    resetarFiltroComMudancaDoFormVariavelOuPontos(v, ignorarPontos) {
      this.filtro.filter = '';
      this.listarRegistros(
        this.controlePaginacao[v ?? this.form.variavel] || 1,
        10,
        ignorarPontos
      );
      this.keyAtualiza++;
    },
    formatarFaixas: function (faixas) {
      return faixas.map((el) => {
        let nome = el.nome;
        if (!nome) nome = `${el.descricao}`;
        return {
          value: el.id,
          text: `${nome}`,
        };
      });
    },
    verificarInstrumentoJaInserido: function (instrumento) {
      const inserido = this.instrumentosAtuais(true).find((i) =>
        this.callBackValidaInstrumento(i, instrumento)
      );
      if (inserido) {
        inserido.pontos = [...this.form.pontos];
        if (!this.selecionarMaisDeUm()) {
          this.removerInstrumentoPontosDuplicados(
            this.form.pontos,
            instrumento
          );
          this.verificarInstrumentosSemPontos();
        }
        return true;
      }
      return false;
    },
    log(...v) {
      console.log(JSON.parse(JSON.stringify(v)));
    },
    SelecionarInstrumentoPadrao: function (item) {
      if (!item.isSelected) return;
      this.tabela.dados.forEach((dado) => {
        if (dado.id != item.id) dado.isSelected = false;
      });
      if (this.verificarInstrumentoJaInserido(item)) return;
      item.pontos = [...this.form.pontos];
      item.variavelId = this.form.variavel;
      item.instrumentoCalibracaoFaixaId = this.tabelaSelecionada.faixaId;
      if (!this.selecionarMaisDeUm()) {
        this.removerInstrumentoPontosDuplicados(this.form.pontos);
        this.verificarInstrumentosSemPontos();
      }
      this.instrumentosPadroesState.push(item);
    },
    removerInstrumentoPontosDuplicados: function (pontos, instrumento) {
      this.instrumentosAtuais(true)
        .filter((p) => (instrumento ? instrumento.id != p.id : true))
        .forEach((instrumento) => {
          pontos.forEach((ponto) => {
            _.remove(instrumento.pontos, (p) => p == ponto);
          });
        });
    },
    verificarInstrumentosSemPontos: function () {
      this.instrumentosPadroesState
        .filter((p) => !p.pontos?.length)
        .forEach((p) => {
          p.isSelected = false;
          _.remove(this.instrumentosPadroesState, (el) => el == p);
        });
      ++this.keyAtualiza;
    },
    podeSelecionar: function (instrumento) {
      // Verifica se o instrumento pode ser selecionado
      return (
        instrumento.validacao == 'Valido' && !!instrumento.faixaSelecionada
      );
    },
    abrirModal: function () {
      this.form.variavel = null;
      this.instrumentosPadroesState = [];
      this.tabela.selecionados = [];
      this.$refs.modal.abrirModal();
      this.resetarFiltros();
      this.valoresClonados = _.cloneDeep(this.valores);
      this.definirinstrumentosPadroesState();
      this.form.pontos = [];
      this.persistente = false;
      this.variavelSetada = false;
      this.listarVariaveis();
    },
    resetarFiltros() {
      this.filtro.filter = '';
      this.filtrar();
    },
    abrirModalPersistente: function () {
      this.abrirModal();
      this.persistente = false;
    },
    fecharModal: function () {
      this.$refs.modal.fecharModal();
    },
    filtrar: function () {
      this.listarRegistros();
    },
    listarVariaveis: function () {
      const params = { flagPublicada: true };
      FormulaService.buscar(
        this.valoresClonados.formulaMensurandoId,
        params
      ).then((res) => {
        this.opcoesVariaveis = res.data.variaveis.map((el) => {
          return {
            value: el.id,
            text: `${el.simbolo} - ${el.unidadeMedida.nome}`,
            grandezaFisicaId: el.grandezaFisica.id,
          };
        });
      });
    },
    selecionarMaisDeUm: function () {
      const resultado = this.valores.colunas.some(
        (el) =>
          el.formulaVariavel &&
          el.formulaVariavel.id === this.form.variavel &&
          el.tipoColuna === 'Referencia'
      );
      return resultado;
    },
    listarRegistros: function (paginaAtual = 1, porPagina = 10) {
      this.tabela.paginaAtual = paginaAtual;
      let parametros = {
        page: paginaAtual,
        amountPerPage: porPagina,
        sort: '-validacao',
        ...this.filtro,
      };
      parametros.IgnoreInstrumentoId = this.instrumentoId;
      let variavel = this.opcoesVariaveis.find(
        (el) => el?.value == this.form.variavel
      );
      if (!variavel) return;
      parametros.FaixaGrandezaFisicaId = variavel.grandezaFisicaId;
      this.$store.dispatch('Layout/iniciarCarregamento');
      InstrumentoService.listarPadrao(parametros)
        .then((res) => {
          this.tabela.dados = res.data.items.map((el) => {
            el.faixaSelecionada =
              el.faixas.length == 1 ? el.faixas[0].id : null;
            return el;
          });

          this.tabela.quantidadeItens = res.data.totalItems;
          this.tabela.quantidadePaginas = res.data.totalPages;
          this.tabela.paginaAtual = paginaAtual;
          this.tabela.porPagina = porPagina;
          this.controlePaginacao[this.form.variavel] = paginaAtual;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    verificarInstrumentosAtuais(opcao) {
      if (opcao) return true;
      return true;
    },
    adicionarInstrumentoState: function () {
      this.instrumentosPadroesState.push(...this.tabela.selecionados);
      ++this.keyAtualizaInstrumentos;
    },
    todosPontosSelecionadosVariavel(variavelId = null) {
      const qtdPontosSelecionados = this.pontosSelecionados(
        true,
        variavelId
      ).length;
      const bool = qtdPontosSelecionados == this.opcoesPontos.length;
      return bool;
    },
    todosPontosSelecionados() {
      const ary = [];
      this.opcoesVariaveis.forEach((variavel) => {
        ary.push(this.todosPontosSelecionadosVariavel(variavel.value));
      });
      return ary.every((p) => p);
    },
    verificarPontosVariaveisSemInstrumento() {
      const validacoes = [];
      this.opcoesVariaveis.forEach((variavel) => {
        validacoes.push(this.todosPontosSelecionadosVariavel(variavel.value));
      });
      return validacoes.every((p) => p);
    },
    alterarInstrumento: function () {
      if (!this.verificarPontosVariaveisSemInstrumento())
        return this.toastAlerta(
          this.$t(
            'modulos.calibracao.valores.alertas.todos_os_pontos_devem_ser_selecionados'
          )
        );
      this.confirmarSalvar().then(() => {
        this.valoresClonados.linhas.forEach((linha) => {
          linha.valores.forEach((valor) => {
            valor.valor = '';
          });
        });

        this.valoresClonados.linhas.forEach((linha) => {
          linha.resultados.forEach((resultado) => {
            resultado.valor = '';
          });
        });

        if (this.form.pontos.length == 0) {
          this.toastErro(
            this.$t(
              'modulos.calibracao.valores.alertas.deve_selecionar_pelo_menos_um_ponto'
            )
          );
          return;
        }
        this.valoresClonados.instrumentosPadroes =
          this.instrumentosAtuaisState();

        this.$emit('salvar-tabela', this.valoresClonados);
      });
    },
    pontosSelecionados: function (filtrarVariavel = false, variavelId = null) {
      const instrumentos = this.instrumentosAtuais(filtrarVariavel, variavelId);
      const pontosIds = instrumentos.flatMap((p) => p.pontos);
      return _.uniq(pontosIds);
    },
    instrumentosAtuaisState() {
      const variaveisComputadasIds = this.variaveisComputadas;
      return this.instrumentosAtuais(null, null, true)
        .filter((el) => variaveisComputadasIds.includes(el.variavelId))
        .map((item) => {
          return {
            formulaVariavel: { id: item.variavelId },
            instrumento: { id: item.id },
            faixa: { id: item.faixaSelecionada },
            instrumentoCalibracaoFaixaId:
              item.instrumentoCalibracaoFaixaId ??
              this.tabelaSelecionada.faixaId,
            pontos: item.pontos.map((el) => {
              return { id: el };
            }),
          };
        });
    },
    encontrarTextoPorId(ids) {
      if (!ids?.length) return '';
      const textos = ids.map((id) => {
        const opcao = this.opcoesPontos.find((opcao) => opcao?.value == id);
        let texto = opcao ? opcao.text : '';
        texto = texto.replace(/(\d+[.,]?\d*).*/, '$1');
        return texto;
      });
      return textos.join('; ');
    },
  },
};
</script>
